<ng-container *ngIf="hasSubcategories() && !isLoading && !hasError">
    <div class="subcategories" *ngIf="subcategories.length > 0">
        <a
                class="subcategories__tile"
                *ngFor="let category of subcategories; trackBy: trackById"
                role="button"
                tabindex="0"
                [routerLink]="['/catalog']"
                [queryParams]="{catalog_id: category.id,page: null}"
                [attr.aria-label]="'Перейти в категорию ' + category.header"
        >

            <div class="subcategories__tile-info">
                <span class="subcategories__tile-title">{{ category.header }}</span>
                <span
                        class="subcategories__tile-count"
                        *ngIf="category.productCount > 0"
                >
          {{ category.productCount | number: '1.0-0' }}
          {{ category.productCount | pluralize:'товар':'товара':'товаров' }}

        </span>
            </div>
            <div class="subcategories__tile-image">
                <img
                        [src]="getImageUri(category.picture)"
                        [alt]="category.header"
                        class="subcategories__tile-img"
                />
            </div>
        </a>
    </div>
</ng-container>

<!-- Состояние загрузки -->
<div class="subcategories subcategories--loading" *ngIf="isLoading">
    <div class="subcategories__tile subcategories__tile--skeleton" *ngFor="let i of [1,2,3,4]">
        <div class="subcategories__tile-image subcategories__skeleton-image"></div>
        <div class="subcategories__tile-info">
            <div class="subcategories__skeleton-title"></div>
            <div class="subcategories__skeleton-count"></div>
        </div>
    </div>
</div>
